import { z } from 'zod';

export const GetUserResponseSchema = z.object({
	advertiser_id: z.string().optional(),
	email: z.string().email().optional(),
	id: z.string(),
	mparticle_id: z.string().optional(),
	phone: z.string().optional(),
});

export type GetUserResponse = z.infer<typeof GetUserResponseSchema>;

export const UserSchema = z.object({
	advertiserId: z.string().nullable(),
	cdpId: z.string().nullable(),
	email: z.string().email().nullable(),
	hashedEmail: z.string().nullable(),
	hashedPhone: z.string().nullable(),
	id: z.string(),
	phone: z.string().nullable(),
});

export type User = z.infer<typeof UserSchema>;
